import { captureException } from "observability";
import { mixpanelClient } from "analytics/mixpanel";
import { EVENTS } from "analytics/mixpanel/events";

export function trackExposure(
  experimentKey: string,
  variationKey: string,
  analyticsId: string
) {
  // Use the local proxy API to avoid CORS issues
  fetch(`/api/experiment-exposure`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      experimentKey,
      analyticsId,
      variant: variationKey
    })
  }).catch((error) => {
    captureException(error, {
      extra: { message: "Error tracking experiment exposure:" }
    });
  });

  // Add Mixpanel tracking
  try {
    // Track the experiment as an event
    mixpanelClient.track(EVENTS.EXPERIMENT_VIEWED.name, {
      [EVENTS.EXPERIMENT_VIEWED.properties.EXPERIMENT_NAME]: experimentKey,
      [EVENTS.EXPERIMENT_VIEWED.properties.EXPERIMENT_VARIATION]: variationKey
    });

    // Also set as a super property for segmentation
    mixpanelClient.setSuperProperty({
      [`Experiment: ${experimentKey}`]: variationKey
    });
  } catch (error) {
    captureException(error as Error, {
      extra: { message: "Error tracking experiment exposure to Mixpanel:" }
    });
  }
}
